<form class="form w-100" novalidate="novalidate" id="kt_login_signup_form" [formGroup]="registrationForm">

  <!-- Below lg the ink panel that carries the brand and the pitch is hidden, so
       on a phone this dialog opened on a pair of role tabs with nothing saying
       what it was. Above lg the panel says it and this stays out of the way. -->
  <div class="d-lg-none mb-6">
    <div class="text-center mb-6"><app-brand-logo size="md"></app-brand-logo></div>
    <h3 class="auth-form__title fw-bolder m-0 mb-0">{{ "AUTH.ASIDE.SIGN_UP_TITLE" | translate }}</h3>
  </div>

  @if (hasError()) {
  <div class="mb-lg-15 alert alert-danger">
    <div class="alert-text font-weight-bold">
      {{ "AUTH.REGISTER_ERROR" | translate }}
    </div>
  </div>
  }

  <div class="row g-2 g-sm-4 mb-8">
    <!-- A segmented pill toggle, not the Metronic pricing-plan control this
         used to be — `data-kt-buttons` / `data-kt-plan="month"|"annual"` were
         lifted whole from a monthly/yearly plan switcher and never meant
         "student" or "parent"; the active state was already driven by
         `switchRole()` and `[ngClass]`, so that plugin markup was doing
         nothing but carrying the wrong semantics. -->
    <div class="role-toggle d-flex mx-auto mb-4 col-12 col-sm-8" role="tablist">
      <button type="button" class="role-toggle__btn fw-bold" data-testid="role-student"
        [class.is-active]="registrationForm.value.is_student" role="tab"
        [attr.aria-selected]="registrationForm.value.is_student" (click)="switchRole(true)">
        นักเรียน
      </button>

      <button type="button" class="role-toggle__btn fw-bold" data-testid="role-parent"
        [class.is-active]="!registrationForm.value.is_student" role="tab"
        [attr.aria-selected]="!registrationForm.value.is_student" (click)="switchRole(false)">
        ผู้ปกครอง
      </button>
    </div>

    <!-- The optional picture, at the size of an optional picture. Centred and
         125px wide it was a 200px-tall centrepiece above eighteen required
         fields — the least important thing on the form, given the most room and
         the first position. -->
    <!-- The optional picture: a small cluster on the left, not a centred portrait
     above eighteen required fields. -->
    <div class="col-12 signup-avatar d-flex align-items-center gap-4 mb-2">
      <div class="signup-avatar__pic">
        <app-upload-image imgSizeCSS="w-64px h-64px" [imageValue]="registrationForm.value.image_url"
          formControlName="image"></app-upload-image>
      </div>
      <button type="button" class="btn btn-sm btn-light-primary px-5 fs-7" (click)="selectImage()">
        {{ "APP.BROWSE_IMAGE" | translate }}
      </button>
    </div>
    <!-- Every field below — account, profile, address — fades together on a
         role switch, not just the nickname field the role actually changes.
         Nothing here stops being valid or gets cleared; this is a visual cue
         that the context changed, the same job the role pill's own colour
         change does for the toggle itself. -->
    <div class="d-flex flex-row flex-wrap gap-6 col-12 role-fields" [class.role-fields--switching]="roleSwitching()">
      <div class="col-12">
        <!-- Eighteen fields in one run reads as a form to be endured. Naming
             the three things being asked for turns it into three short asks,
             and costs one line of type each. -->
        <p class="signup-section fw-medium text-uppercase">{{ "AUTH.SECTION_ACCOUNT" | translate }}</p>
        <div class="row gy-4">
          <!-- Full width, not `col-sm-6` beside an empty spacer div: email
               alone on its row is the actual layout being asked for, so it is
               stated directly rather than achieved by padding out the grid
               with a div that draws nothing. -->
          <div class="col-12">
            <app-input label="APP.EMAIL" name="email" formControlName="email"
              [control]="registrationForm.controls['email']" placeholder="APP.EMAIL" [labelMode]="LabelMode.DEFAULT"
              [required]="true" [error]="error()?.email"></app-input>
          </div>
          <div class="col-12 col-sm-6">
            <app-input type="password" autocomplete="new-password" label="AUTH.INPUT.PASSWORD" name="password"
              formControlName="password" [control]="registrationForm.controls['password']"
              placeholder="AUTH.INPUT.PASSWORD" [labelMode]="LabelMode.DEFAULT" [required]="true"
              [error]="error()?.password"></app-input>
          </div>
          <div class="col-12 col-sm-6">
            <app-input type="password" autocomplete="new-password" label="AUTH.INPUT.CONFIRM_PASSWORD"
              name="password_confirmation" formControlName="password_confirmation"
              [control]="registrationForm.controls['password_confirmation']" placeholder="AUTH.INPUT.CONFIRM_PASSWORD"
              [labelMode]="LabelMode.DEFAULT" [required]="true" [error]="error()?.password_confirmation"></app-input>
            @if( registrationForm.controls['password'].value &&
            registrationForm.controls['password_confirmation'].value &&
            registrationForm.controls['password_confirmation'].errors &&
            registrationForm.controls['password_confirmation'].errors.ConfirmPassword){

            <div class="fv-plugins-message-container">
              <div class="fv-help-block">
                {{ "VALIDATOR.PASSWORD_MISMATCH" | translate }}
              </div>
            </div>
            }
          </div>

          <div class="col-12">
            <p class="signup-section fw-medium text-uppercase mt-4">{{ "AUTH.SECTION_PROFILE" | translate }}</p>
          </div>
          <div class="col-12 col-sm-6">
            <app-input label="APP.FIRST_NAME" name="first_name" formControlName="first_name"
              [control]="registrationForm.controls['first_name']" placeholder="APP.FIRST_NAME"
              [labelMode]="LabelMode.DEFAULT" [required]="true" [error]="error()?.first_name"></app-input>
          </div>
          <div class="col-12 col-sm-6">
            <app-input label="APP.LAST_NAME" name="last_name" formControlName="last_name"
              [control]="registrationForm.controls['last_name']" placeholder="APP.LAST_NAME"
              [labelMode]="LabelMode.DEFAULT" [required]="true" [error]="error()?.last_name"></app-input>
          </div>
          <!-- The only field the role toggle adds or removes. Kept in the DOM
               and faded by class rather than mounted/unmounted by `@if`: an
               `@if` toggle also reflows every field after it (birthdate and
               phone jumping sideways into or out of nickname's slot), which
               read as more of a glitch than the field itself appearing. This
               way the grid cell is always there, so nothing around it moves —
               only this field's opacity changes, both appearing AND
               disappearing (an `@if` exit has nothing left to animate). -->
          @if(registrationForm.value.is_student){
          <div class="col-12 col-sm-6 role-field opacity-100 visible"
            [attr.aria-hidden]="!registrationForm.value.is_student">
            <app-input label="APP.NICKNAME" name="nickname" formControlName="nickname"
              [control]="registrationForm.controls['nickname']" placeholder="APP.NICKNAME"
              [labelMode]="LabelMode.DEFAULT" [error]="error()?.nickname"></app-input>
          </div>
          }
          <div class="col-12 col-sm-6">
            <app-datepicker label="APP.DOB" name="birthdate" formControlName="birthdate" placeholder="APP.DATE_FORMAT"
              [labelMode]="LabelMode.DEFAULT" [required]="true" [error]="error()?.birthdate"></app-datepicker>
          </div>
          <div class="col-12 col-sm-6">
            <app-input label="APP.PHONE" name="phone" formControlName="phone"
              [control]="registrationForm.controls['phone']" placeholder="APP.PHONE" [labelMode]="LabelMode.DEFAULT"
              type="text" mask="0XX-XXX-XXXX" [dropSpecialCharacters]="true" [required]="true"
              [error]="error()?.phone"></app-input>
          </div>
        </div>

      </div>
      <div class="col-12">
        <p class="signup-section fw-medium text-uppercase">{{ "AUTH.SECTION_ADDRESS" | translate }}</p>
        <app-form [form]="registrationForm" [getterError]="error" [selectAppendTo]="null"></app-form>
      </div>
    </div>



  </div>
  <!--end::Form group-->
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row mb-6" data-testid="register-agree">
    <div class="d-flex align-items-start gap-1">
      <app-checkbox formControlName="agree" name="agree" [labelMode]="LabelMode.NO_LABEL"
        [required]="true"></app-checkbox>
      <span class="form-check-label fw-semibold text-gray-700 fs-base ms-1 mb-0">
        {{ "AUTH.PRIVACY_CONSENT_PREFIX" | translate }}&nbsp;<a routerLink="/privacy-policy" target="_blank"
          rel="noopener" class="ms-1 link-primary">{{ "FOOTER.LEGAL.PRIVACY" | translate }}</a>
      </span>
    </div>
    @if (registrationForm.controls['agree'].touched && !registrationForm.controls['agree'].value) {
    <div class="text-danger fs-8 mt-1">{{ "AUTH.PRIVACY_CONSENT_REQUIRED" | translate }}</div>
    }
  </div>
  <!--end::Form group-->

  <p class="signup-policy text-center">{{ "AUTH.POLICY" | translate }}</p>

  <div class="d-flex mb-10 justify-content-center">
    <button type="submit" id="kt_sign_up_submit" data-testid="register-submit" [disabled]="
        registrationForm.invalid || !registrationForm.controls['agree'].value
      " class="btn btn-primary w-100 mw-200px" (click)="submit()">
      @if ((isLoading$ | async) === false) {
      <span class="indicator-label">{{
        "AUTH.SUBMIT_SIGN_UP" | translate
        }}</span>
      } @if (isLoading$ | async) {
      <span class="indicator-progress" [style.display]="'block'">
        {{ "AUTH.REGISTERING" | translate }}
        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
      </span>
      }
    </button>
  </div>

  <div class="text-gray-600 text-center fw-semibold fs-7">
    {{ "AUTH.ALREADY_REGISTER" | translate }}

    <a class="link-primary fw-semibold cursor-pointer" (click)="updateAuthState(AuthStates.UNAUTHORIZED)">
      {{ "AUTH.SIGN_IN" | translate }}
    </a>
  </div>
</form>

<ng-template #formError let-control="control" let-message="message" let-validation="validation">
  @if (control.hasError(validation) && (control.dirty || control.touched)) {
  <div class="fv-plugins-message-container">
    <div class="fv-help-block">
      <span role="alert">
        {{ message }}
      </span>
    </div>
  </div>
  }
</ng-template>